import { KyResponse } from 'ky';

type OneBadResponseErrorParams = { response: KyResponse };

export default class OneBadResponseError extends Error {
  response: KyResponse;

  constructor({ response }: OneBadResponseErrorParams, cause?: unknown) {
    super('Bad response error', { cause });

    this.response = response;

    Object.setPrototypeOf(this, OneBadResponseError.prototype);
  }

  getResponse() {
    return this.response;
  }
}
